module.exports = __webpack_public_path__ + "media/tycho2t3_80_grey_py.964a4931.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_grey_py.jpg
// module id = 1097
// module chunks = 0